import { Component, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MainPanelActions } from '../../../../actions/app/main-panel.actions';
import { NkSidebarService } from '../../../../components/sidebar/sidebar.service';
import { UserProfileComponent } from '../../../../modals/user-profile/user-profile.component';
import { AuthService } from '../../../../pages/auth/auth.service';
import { SnackBarService } from '../../../../services/app-services/snack-bar.service';
import {
  reload,
  reloadName,
  UsersService,
} from '../../../../services/users.service';
import { ToggleNavigationOpen } from '../../../../stores/app/navbar.state';
import { navigation } from '../../navigation/navigation';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { NkSearchBarModule } from '../../../../components';
import { UserProfileModule } from '../../../../modals/user-profile/user-profile.module';
import { NkSharedModule } from '../../../../shared/shared.module';
import { NkShortcutsComponent } from '../../../../components/shortcuts/shortcuts.component';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports:[
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatSelectModule,
    MatToolbarModule,
    NkSearchBarModule,
    NkSharedModule,
    ReactiveFormsModule,
    RouterModule,
    UserProfileModule,
    NkShortcutsComponent
  ]
})
export class NkToolbarComponent implements OnDestroy {
  public userStatusOptions: any[];
  public languages: any;
  public selectedLanguage: any;
  public showLoadingBar!: boolean;
  public horizontalNav!: boolean;
  public noNav!: boolean;
  public navigation: any;
  public data: any;
  public userData: any;

  public dialogRef!: MatDialogRef<NkToolbarComponent>;
  public routerEventsSubscription: Subscription;
  constructor(
    private readonly router: Router,
    private readonly sidebarService: NkSidebarService,
    private readonly translate: TranslateService,
    private readonly store: Store,
    private readonly dialog: MatDialog,
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly dialogService: MatDialog,
    private readonly usersService: UsersService,
    private readonly snackService: SnackBarService
  ) {
    this.getSingleUserPic();
    reload.subscribe((v) => {
      this.userData.pic = Object.values(v as object);
    });
    reloadName.subscribe((v) => {
      this.userData.name = Object.values(v as object);
    });
    this.userStatusOptions = [
      {
        title: 'Online',
        icon: 'icon-checkbox-marked-circle',
        color: '#4CAF50',
      },
      { title: 'Away', icon: 'icon-clock', color: '#FFC107' },
      {
        title: 'Do not Disturb',
        icon: 'icon-minus-circle',
        color: '#F44336',
      },
      {
        title: 'Invisible',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#BDBDBD',
      },
      {
        title: 'Offline',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#616161',
      },
    ];

    this.languages = [
      { id: 'en', title: 'English', flag: 'us' },
      { id: 'tr', title: 'Turkish', flag: 'tr' },
    ];

    this.selectedLanguage = this.languages[0];

    this.routerEventsSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showLoadingBar = true;
      }
      if (event instanceof NavigationEnd) {
        this.showLoadingBar = false;
      }
    });

    this.navigation = navigation;
  }

  public logout() {
    this.authService
      .logout()
      .pipe(catchError(() => of(0)))
      .subscribe(() => window.location.reload());
  }

  public profile() {
    this.getSingleUser();
  }

  viewUserProfile() {
    this.router.navigate(['profile']);
  }

  private async getSingleUser() {
    await this.usersService.getSingleUserProfile().subscribe(
      (data: any) => {
        const result = { data };
        this.data = result;
       
       const dialogRef = this.dialogService.open(UserProfileComponent, {
  data: {
    profileData: this.data,
  },
  width: '400px',
  panelClass: 'custom-dialog-style'
});
      },
      () => {
        this.snackService.error('Something went wrong');
      }
    );
  }
  private getSingleUserPic() {
    this.usersService.getSingleUserProfile().subscribe(
      (data: any) => {
        const result = { data };
        // this.loader.hide();

        this.data = result;
        this.userData = this.data.data;
       
      },
      () => {
        this.snackService.error('Something went wrong');
      }
    );
  }
  toggleSidebarOpened() {
    this.store.dispatch(new ToggleNavigationOpen());
  }

  setLanguage(lang: any) {
    // Set the selected language for toolbar
    this.selectedLanguage = lang;
    // Use the selected language for translations
    this.translate.use(lang.id);
  }

  ngOnDestroy() {
    this.routerEventsSubscription?.unsubscribe();
  }

  openThemePanel() {
    this.store.dispatch(new MainPanelActions.ThemeOptionPanelOpen(true));
  }
}
